import Link from 'next/link'
import { useRouter } from 'next/router'
import React from 'react'
import { Text, View } from 'reshaped'

type NavItemProps = {
  href: string
  label: string
}

const NavItem: React.FC<NavItemProps> = ({ href, label }) => {
  const { pathname } = useRouter()
  const isActive = pathname === href

  return (
    <View paddingInline={3} paddingTop={2} paddingBottom={2}>
      <Link href={href}>
        <Text
          color={isActive ? 'primary' : 'neutral-faded'}
          variant="body-2"
          weight={isActive ? 'semibold' : 'medium'}
        >
          {label}
        </Text>
      </Link>
    </View>
  )
}

export function NavigationMenu() {
  return (
    <View direction="row">
      <NavItem href="/claim" label="Claim" />
      <NavItem href="/faq" label="FAQ" />
    </View>
  )
}
